import { Dispatch, SetStateAction, useState } from 'react';
import { useCheckDevice } from './UseCheckDevice';

export const usePagination = (
  count: number,
  currentPageProps?: number,
  pageSizeProps?: number,
): PaginationType => {
  const { isMobileDevice } = useCheckDevice();
  const [pageSize, setPageSize] = useState(pageSizeProps || (!isMobileDevice ? 10 : 50));
  const [currentPage, setCurrentPage] = useState(currentPageProps ? currentPageProps + 1 : 1);
  const totalPages = Math.ceil(count / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  return {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    totalPages,
    startIndex,
    endIndex,
  };
};

export type PaginationType = {
  pageSize: number;
  currentPage: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  setPageSize: Dispatch<SetStateAction<number>>;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};
